import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/saas-overrides.css';
import App from './App';

const rootEl = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
